import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { SEARCH_INPUT_BASE_CLASSNAME } from './Constants';
import { createSearchInput } from './SearchInput';
createComponents(".".concat(SEARCH_INPUT_BASE_CLASSNAME), createSearchInput, NO_PATTERN_BUSINESS_LOGIC);
